export * from './messaging-form.reducer';
export * from './messaging-form.effects';
export * from './messaging-form.messages';

export const ATTACHMENTS_LENGTH = 4;
export const ATTACHMENTS_FORMAT = '.txt,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,image/*';
